module.exports = __webpack_public_path__ + "static/media/nota.621bf04c.svg";